import { useHistory } from 'react-router-dom';

import { Location } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import { HintPopup } from '@cobliteam/base-components';
import withPermission from '@cobliteam/base-components/src/PermissionsGate/PermissionsGate';

import { Button } from '@cobliteam/ui/components';
import { SettingsIcon } from '@cobliteam/ui/icons';

import MediaPermissions from '../../permissions';

interface EventSensibilityButtonProps {
  hasIcon: boolean;
}

const getButton = (hasIcon: boolean, onClick: () => void, disabled: boolean) => {
  const variant = hasIcon ? 'text' : 'contained';
  const buttonIcon = hasIcon ? <SettingsIcon /> : <></>;

  return (
    <Button variant={variant} startIcon={buttonIcon} size='condensed' onClick={onClick} disabled={disabled}>
      Configurar eventos
    </Button>
  );
};

const EventSensibilityButton = ({ hasIcon }: EventSensibilityButtonProps) => {
  const history = useHistory();

  const onClick = () => {
    Analytics.track('Event Sensibility Button Clicked');
    history.push(`${Location.CONFIG}?tab=events-configuration`);
  };

  return getButton(hasIcon, onClick, false);
};

const EventSensibilityButtonWithPermission = withPermission(MediaPermissions.CONFIG_AND_VIEW_CUSTOM_ALERTS, EventSensibilityButton, ({ hasIcon, onClick }) => (
  <HintPopup title='Você não possui permissão para visualizar a página' arrow placement='bottom-end'>
    <div>{getButton(hasIcon, onClick, true)}</div>
  </HintPopup>
));

export default EventSensibilityButtonWithPermission;
